export const config = {
    stakeSeries: [{
        defaultStake: 15,
        id: 3146,
        isDefault: true,
        pulseBettingStakeValuesSeries: [1, 5, 10, 15, 20, 50, 100]
    }, {
        defaultStake: 0,
        id: 3147,
        isDefault: false,
        pulseBettingStakeValuesSeries: [1, 2, 5, 7, 10, 25, 50]
    }, {
        defaultStake: 0,
        id: 3151,
        isDefault: false,
        pulseBettingStakeValuesSeries: [5, 10, 25, 50, 100, 200]
    }, {
        defaultStake: 2,
        id: 3312,
        isDefault: false,
        pulseBettingStakeValuesSeries: [1, 2, 3, 4, 5, 10, 25, 50, 100, 250, 500]
    }],
    stakeSeriesWithoutDefault:[{
        defaultStake: 15,
        id: 3146,
        isDefault: false,
        pulseBettingStakeValuesSeries: [1, 5, 10, 15, 20, 50, 100]
    }],
    autoCloseTimeout: 5000,
    preCountDownTimerInterval: 1000 // ms
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./blocks/PulseBetMarkets/config/config.ts